import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  openLoginModal,
  setLoginModal,
} from "../store/auth-slice";

const AuthGuard = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      // Store the attempted URL
      sessionStorage.setItem("redirectUrl", location.pathname);
      // Open login modal
      dispatch(setLoginModal(true));
      // Redirect to home page if not already there
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      }
    }
  }, [isAuthenticated, dispatch, navigate, location]);

  return isAuthenticated ? children : null;
};

export default AuthGuard;
